import { Divider } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { observer } from 'mobx-react-lite';
import { withSnackbar, WithSnackbarProps } from 'notistack';
import React, { useContext, useEffect, useState } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import WindsorApi from '../api/WindsorApi';
import LinkRouter from '../common/LinkRouter';
import LoadingIndicator from '../common/LoadingIndicator';
import MobxContext from '../mobx/MobxContext';
import FamilySettingsForm from './FamilySettingsForm';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: 1200,
      margin: 'auto'
    },
    divider: {
      marginBottom: 16,
      marginTop: 8
    },
    breadcrumb: {
      marginBottom: 16
    }
  })
);

const windsorApi = new WindsorApi();

function EditFamilySettingsPage(props: RouteComponentProps<any> & WithSnackbarProps) {
  const { match: { params: { familyId } }, history, enqueueSnackbar } = props;
  const classes = useStyles({});
  const [originalFamily, setOriginalFamily] = useState(null);
  const [family, setFamily] = useState(null);
  const { cspGroupStore } = useContext(MobxContext);

  useEffect(() => {
    windsorApi.getFamily(familyId).then(family => {
      if (!family.AllowedARNs) {
        family.AllowedARNs = [];
      }
      setOriginalFamily(family);
      setFamily(family);
    });
  }, [familyId]);

  const onFamilyChange = (family: any) => {
    setFamily(family);
  };

  const onSave = () => {
    return windsorApi.updateFamily(family);
  };

  const onSaveComplete = () => {
    enqueueSnackbar('Family updated');
    history.push(`/families/${familyId}?tab=settings`);
  };

  const onCancel = () => {
    history.push(`/families/${familyId}`);
  };

  return family && originalFamily && cspGroupStore.groups ? (
    <div className={classes.root}>
      <Breadcrumbs aria-label="breadcrumb">
        <LinkRouter color="textSecondary" to="/families">
          Families
        </LinkRouter>
        <LinkRouter color="textSecondary" to={`/families/${familyId}`}>
          {originalFamily.Name}
        </LinkRouter>
        <Typography color="textPrimary">edit</Typography>
      </Breadcrumbs>
      <Divider className={classes.divider} light />
      <FamilySettingsForm 
        title="Edit Family Settings"
        family={family} 
        groups={cspGroupStore.groups}
        onFamilyChange={onFamilyChange} 
        onSave={onSave}
        onSaveComplete={onSaveComplete}
        onCancel={onCancel}
      />
    </div>
  ) : <LoadingIndicator loading={true} />;
};

export default withRouter(withSnackbar(observer(EditFamilySettingsPage)));
